var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97609 0H34.0174C35.1065 0 35.9935 0.85 35.9935 1.89375V22.1C35.9935 23.1438 35.1065 23.9937 34.0174 23.9937H1.97609C0.886956 24 0 23.15 0 22.1062V1.89375C0 0.85 0.886956 0 1.97609 0Z",
    fill: "#B22234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0130435 1.70312H35.9935C36 1.76562 36.0065 1.82812 36.0065 1.89687V3.73437H0V1.89062C0 1.82812 0.00652174 1.76562 0.0130435 1.70312ZM36 5.41562V7.44062H0V5.41562H36ZM36 9.12812V11.1531H0V9.12812H36V9.12812ZM36 12.8406V14.8656H0V12.8406H36V12.8406ZM36 16.5531V18.5781H0V16.5531H36V16.5531ZM36 20.2656V22.0969C36 22.1594 35.9935 22.2281 35.987 22.2906H0.0130435C0.00652174 22.2344 0 22.1656 0 22.1031V20.2719H36V20.2656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5652 0V12.925H0V1.89375C0 0.85 0.886956 0 1.97609 0H13.5652Z",
    fill: "#3C3B6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799456 1.78906L1.24946 3.13281L0.0625 2.30156H1.53641L0.342935 3.13281L0.799456 1.78906Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799456 4.39062L1.24946 5.73437L0.0625 4.90313H1.53641L0.342935 5.73437L0.799456 4.39062Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799456 6.98438L1.24946 8.32812L0.0625 7.49687H1.53641L0.342935 8.32812L0.799456 6.98438Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799456 9.58594L1.24946 10.9297L0.0625 10.0984H1.53641L0.342935 10.9297L0.799456 9.58594Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39321 0.484375L2.84973 1.82812L1.65625 0.996875H3.13668L1.93668 1.82812L2.39321 0.484375Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39321 3.08594L2.84973 4.42969L1.65625 3.59844H3.13668L1.93668 4.42969L2.39321 3.08594Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39321 5.6875L2.84973 7.03125L1.65625 6.2H3.13668L1.93668 7.03125L2.39321 5.6875Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39321 8.28906L2.84973 9.63281L1.65625 8.80156H3.13668L1.93668 9.63281L2.39321 8.28906Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39321 10.8906L2.84973 12.2344L1.65625 11.4031H3.13668L1.93668 12.2344L2.39321 10.8906Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99477 1.78906L4.45129 3.13281L3.25781 2.30156H4.73173L3.53825 3.13281L3.99477 1.78906Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99477 4.39062L4.45129 5.73437L3.25781 4.90313H4.73173L3.53825 5.73437L3.99477 4.39062Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99477 6.98438L4.45129 8.32812L3.25781 7.49687H4.73173L3.53825 8.32812L3.99477 6.98438Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99477 9.58594L4.45129 10.9297L3.25781 10.0984H4.73173L3.53825 10.9297L3.99477 9.58594Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58852 0.484375L6.03852 1.82812L4.85156 0.996875H6.32548L5.132 1.82812L5.58852 0.484375Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58852 3.08594L6.03852 4.42969L4.85156 3.59844H6.32548L5.132 4.42969L5.58852 3.08594Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58852 5.6875L6.03852 7.03125L4.85156 6.2H6.32548L5.132 7.03125L5.58852 5.6875Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58852 8.28906L6.03852 9.63281L4.85156 8.80156H6.32548L5.132 9.63281L5.58852 8.28906Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58852 10.8906L6.03852 12.2344L4.85156 11.4031H6.32548L5.132 12.2344L5.58852 10.8906Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18227 1.78906L7.63879 3.13281L6.44531 2.30156H7.91923L6.72575 3.13281L7.18227 1.78906Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18227 4.39062L7.63879 5.73437L6.44531 4.90313H7.91923L6.72575 5.73437L7.18227 4.39062Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18227 6.98438L7.63879 8.32812L6.44531 7.49687H7.91923L6.72575 8.32812L7.18227 6.98438Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18227 9.58594L7.63879 10.9297L6.44531 10.0984H7.91923L6.72575 10.9297L7.18227 9.58594Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77602 0.484375L9.23254 1.82812L8.03906 0.996875H9.51298L8.3195 1.82812L8.77602 0.484375Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77602 3.08594L9.23254 4.42969L8.03906 3.59844H9.51298L8.3195 4.42969L8.77602 3.08594Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77602 5.6875L9.23254 7.03125L8.03906 6.2H9.51298L8.3195 7.03125L8.77602 5.6875Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77602 8.28906L9.23254 9.63281L8.03906 8.80156H9.51298L8.3195 9.63281L8.77602 8.28906Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77602 10.8906L9.23254 12.2344L8.03906 11.4031H9.51298L8.3195 12.2344L8.77602 10.8906Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3698 1.78906L10.8263 3.13281L9.63281 2.30156H11.1067L9.91977 3.13281L10.3698 1.78906Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3698 4.39062L10.8263 5.73437L9.63281 4.90313H11.1067L9.91977 5.73437L10.3698 4.39062Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3698 6.98438L10.8263 8.32812L9.63281 7.49687H11.1067L9.91977 8.32812L10.3698 6.98438Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3698 9.58594L10.8263 10.9297L9.63281 10.0984H11.1067L9.91977 10.9297L10.3698 9.58594Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 0.484375L12.42 1.82812L11.2266 0.996875H12.7005L11.507 1.82812L11.9635 0.484375Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 3.08594L12.42 4.42969L11.2266 3.59844H12.7005L11.507 4.42969L11.9635 3.08594Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 5.6875L12.42 7.03125L11.2266 6.2H12.7005L11.507 7.03125L11.9635 5.6875Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 8.28906L12.42 9.63281L11.2266 8.80156H12.7005L11.507 9.63281L11.9635 8.28906Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 10.8906L12.42 12.2344L11.2266 11.4031H12.7005L11.507 12.2344L11.9635 10.8906Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/us_flag.9b3cdf2081e97c70a4efc4ea7c877908.svg";
export { ForwardRef as ReactComponent };